<template>
  <v-container>
   <img src="https://cdn.mos.cms.futurecdn.net/8SyJjYXNUcvnfLm4vamuGn-1024-80.jpg.webp" />
   <img src="https://images-na.ssl-images-amazon.com/images/I/51Dg7PFL3mL._AC_SY355_.jpg" />

   <!-- <HelloWorld /> -->
  </v-container>
</template>

<script>
  /*import HelloWorld from '@/components/HelloWorld.vue'*/

  export default {
    components: {
      /*HelloWorld*/
    },
  }
</script>
